import { render, staticRenderFns } from "./InitialAnimation.vue?vue&type=template&id=898107a8&scoped=true"
import script from "./InitialAnimation.vue?vue&type=script&lang=js"
export * from "./InitialAnimation.vue?vue&type=script&lang=js"
import style0 from "./InitialAnimation.vue?vue&type=style&index=0&id=898107a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898107a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('898107a8')) {
      api.createRecord('898107a8', component.options)
    } else {
      api.reload('898107a8', component.options)
    }
    module.hot.accept("./InitialAnimation.vue?vue&type=template&id=898107a8&scoped=true", function () {
      api.rerender('898107a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/login/InitialAnimation.vue"
export default component.exports